<template>
    <div class="mt-8">
        <div class="mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mt-2 grid grid-cols-1 gap-5">
                <component
                    :is="widget.name"
                    v-for="(widget, index) in widgets"
                    :widget="widget"
                    :key="`${widget.name}_${index}`"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ActivityLogGraphWidget from '@/components/Widgets/Common/ActivityLogGraphWidget.vue';

export default {
    name: 'DashboardCentralSchoolWidgets',
    components: {
        'activity-log-graph-widget': ActivityLogGraphWidget,
    },
    props: ['widgets'],
};
</script>
